import { RequestService } from "../../../../../common/services/RequestService";
import { GET_CUSTOMER_COMPANIES } from "../../../../../common/api/constants";

export const getActualClients = async profileId => {
  const response = await RequestService.get(
    GET_CUSTOMER_COMPANIES.replace("{company_id}", profileId)
  );
  return response.data;
};
